<template lang="pug">
  div.msn.separate-collection-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
          v-model="tabView"
          :tabs="[{tab1: 'Общие сведения'},{characteristic: 'Характеристика'},{'garbage-house': 'Отходообразователи'},{tab2: 'Отходы'},{tab3: 'Обслуживание'},{tab4: 'Документы'}]"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView === 'tab1'")
            div.body
              div.col
                e-form-subtitle(text="Реквизиты")

                e-form-group(
                  name="name"
                  inputType="input"
                  label="Идентификатор"
                  :model="fields"
                  :required="true"
                  tabView="tab1"
                )
                e-form-group(
                  name="owner"
                  inputType="input"
                  label="Балансодержатель"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="daily_norm"
                  inputType="input"
                  label="Суточная норма накопления, тонн"
                  :model="fields"
                  validationRule="double"
                  tabView="tab1"
                )
                e-form-group(
                  name="containers_count"
                  inputType="input"
                  label="Количество контейнеров"
                  :model="fields"
                  validationRule="number"
                  tabView="tab1"
                  :disabled="true"
                )
                e-form-group(
                  name="volume_count"
                  inputType="input"
                  label="Общий объем контейнерной площадки, куб. м."
                  :model="fields"
                  tabView="tab1"
                  :disabled="true"
                )

                e-form-group(
                  name="is_temporarily"
                  inputType="checkbox"
                  caption="Площадка временного назначения"
                  :model="fields"
                  tabView="tab1"
                )

              div.col
                div.col-block

                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab2"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )

                e-form-group(
                  name="status_id"
                  inputType="select"
                  :required="true"
                  label="Статус объекта"
                  :model="fields"
                  tabView="tab1"
                  :options="statuses"
                )
                e-form-group(
                  name="close_date"
                  inputType="calendar"
                  label="Дата закрытия"
                  :model="fields"
                  tabView="tab1"
                  :disabled="fields.status_id !== notActive"
                )
                e-form-group(
                  name="msn_container_area_roof_id"
                  inputType="select"
                  label="Вид площадки"
                  :model="fields"
                  tabView="tab1"
                  :options="roofTypes"
                )
                e-form-group(
                  name="msn_container_area_fence_id"
                  inputType="select"
                  label="Тип ограждения"
                  :model="fields"
                  tabView="tab1"
                  :options="fenceTypes"
                )
                e-form-group(
                  name="msn_container_area_floor_id"
                  inputType="select"
                  label="Тип подстилающей поверхности"
                  :model="fields"
                  tabView="tab1"
                  :options="underSurfaceTypes"
                )
                e-form-group(
                  name="is_separate"
                  inputType="select"
                  :required="true"
                  label="Наличие раздельного сбора"
                  :model="fields"
                  tabView="tab1"
                  :options="isSeparateTypes"
                )
                e-form-group(
                  name="msn_by_type_id"
                  inputType="select"
                  label="Тип контейнерной площадки"
                  :model="fields"
                  tabView="tab1"
                  :options="msnByTypes"
                )

              div.col
                e-form-subtitle(text="Местоположение")
                e-location(
                  :formValidator="formValidator"
                  :model="fields"
                  name="address"
                  :required="true"
                  :addressData="addressData"
                  tabView="tab1"
                )

          div(v-show="tabView === 'characteristic'")
            container-table(
              :id="fields.id"
              :fields="fields"
              ref="containerTable"
              tabView="characteristic"
            )

            // вкладка ОТХОДЫ
          div(v-show="tabView === 'tab2'")
            garbage-table(
              :id="fields.id"
              ref="garbageTable"
              tabView="tab2"
              :fields="fields"
            )
          div(v-show="tabView === 'sensor'")
            div.body
              div.col
                e-form-group(
                  name="wasteout_id"
                  inputType="select"
                  label="Датчик"
                  :model="fields"
                  tabView="tab1"
                  :options="wasteout"
                  optionTextKey="pointId"
                  optionValueKey="pointId"
                  @change="onWasteoutChange"
                )
                e-form-group(
                  name="fullnessPercent"
                  label="% Заполненности"
                  :model="fields.wasteoutLast"
                  tabView="tab1"
                  :disabled="true"
                )
                e-form-group(
                  name="status_msn_id"
                  inputType="select"
                  :disabled="true"
                  label="Статус"
                  :model="fields"
                  tabView="tab1"
                  :options="sensorStatuses"
                )
              div.col
                e-form-group(
                  name="pointId"
                  inputType="input"
                  label="Идентификатор площадки"
                  :model="fields.wasteoutLast"
                  :disabled="true"
                  tabView="sensor"
                )

                e-form-group(
                  name="speed"
                  inputType="input"
                  label="Скорость наполнения"
                  :model="wasteoutCalc"
                  :disabled="true"
                  tabView="sensor"
                )
                e-form-group(
                  name="lastVisit"
                  inputType="input"
                  label="Последнее посещение"
                  :model="fields.wasteoutLast"
                  :disabled="true"
                  tabView="sensor"
                )

                e-form-group(
                  name="lastMessage"
                  inputType="input"
                  label="Последнее сообщение"
                  :model="fields.wasteoutLast"
                  :disabled="true"
                  tabView="sensor"
                )

              div.col
                e-form-group(
                  name="lastFilled"
                  inputType="input"
                  label="Последнее наполнение"
                  :model="fields.wasteoutLast"
                  :disabled="true"
                  tabView="sensor"
                )

                e-form-group(
                  name="scheduledTimeFilling"
                  inputType="input"
                  label="Плановое время заполнения"
                  :model="fields.wasteoutLast"
                  :disabled="true"
                  tabView="sensor"
                )

          div(v-show="tabView === 'garbage-house'")
            garbage-house-container-table(
              :id="fields.id"
              ref="garbageHouseTable"
              tabView="garbage-house"
            )

          //вкладка ОБСЛУЖИВАНИЕ
          div(v-show="tabView === 'tab3'")
            service-table(
              :id="fields.id"
              ref="serviceTable"
              tabView="tab3"
            )

          //Документы
          div(v-show="tabView === 'tab4'")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )

</template>

<script>
  import { core, msn }              from '@/api/api-endpoints'
  import msnForm                    from '../mixins/msn-form.js'
  import GarbageTable               from '../../msn/components/garbage-table.vue'
  import ServiceTable               from './components/service-table'
  import ContainerTable             from './components/container-table'
  import GarbageHouseContainerTable from './components/garbage-house-container-table'
  import DocumentsTable             from '@/common/layout/documents/DocumentsTable'

  export default {
    components: {
      GarbageHouseContainerTable,
      ContainerTable,
      DocumentsTable,
      ServiceTable,
      GarbageTable
    },
    mixins:     [msnForm],
    data() {
      return {
        tabView: 'tab1',
        fields:  {
          name:          '',
          status_id:     '',
          latitude:      '',
          longitude:     '',
          msn_type_id:   1,
          is_separate:   0,
          wasteoutLast:  {},
          status_msn_id: null,
          wasteout_id:   ''
        },
        errors:  null,
        dadata:  {}
      }
    },
    methods: {
      getContainersEndpoint(route) {
        if (route && route.params.id) {
          return msn.containersTable(route.params.id, {
            query: {
              type: 'tko'
            }
          })
        }
        return null
      },
      getContainersSeparateEndpoint(route) {
        if (route && route.params.id) {
          return msn.containersTable(route.params.id, {
            query: {
              type: 'separate_collection'
            }
          })
        }
        return null
      },
      getCollectionEndpoint() {
        // return core.statuses({ fields: 'msn_container_roof,msn_container_floor,msn_container_fence,status,msn_by_type,status_msn' })
        return core.collection(
          'msn_container_roof,msn_container_floor,msn_container_fence,status,msn_by_type,status_msn',
          {query: {type: 'msn'}}
        )
      },
      getWasteoutEndpoint() {
        return core.statuses({ fields: 'wasteout' })
      },
      getDeleteUrl(id) {
        return msn.containerDelete(id)
      },
      getUpdateOrCreateUrl() {
        return msn.containerUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint(route) {
        if (!route.params.id) {
          return null
        }
        return msn.container(route.params.id)
      }
    }
  }
</script>
